(() => {
  'use strict';
  const cookieName = 'fabienne_language';
  const allowed = ['en', 'sr', 'ru'];
  const configElement = document.getElementById('FabienneLocale');
  let config;
  try { config = JSON.parse(configElement?.textContent || '{}'); } catch { return; }
  const current = (config.language || document.documentElement.lang).split('-')[0];
  const available = (config.available || allowed).map(value => value.split('-')[0]);
  const remember = value => {
    const language = value?.split('-')[0];
    if (!allowed.includes(language)) return;
    document.cookie = `${cookieName}=${language}; Path=/; Max-Age=31536000; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-language]');
    if (link) remember(link.dataset.language);
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-native-language]')) remember(event.target.value);
  }, true);
  document.addEventListener('submit', event => {
    const select = event.target.querySelector?.('[name="locale_code"], [name="language_code"]');
    if (select) remember(select.value);
  }, true);
  if (config.enabled === false || window.Shopify?.designMode || config.designMode) return;
  if (current !== 'en') {
    try { sessionStorage.removeItem(`fabienne_locale_redirect_${current}`); } catch {}
    return;
  }
  const saved = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(cookieName + '='))?.split('=')[1];
  const switchTo = language => {
    if (language === current || !available.includes(language)) return;
    try {
      const key = `fabienne_locale_redirect_${language}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch { return; }
    if (config.mode === 'shopify') {
      const form = document.createElement('form');
      form.method = 'POST'; form.action = '/localization'; form.hidden = true;
      const fields = {form_type:'localization', _method:'PUT', language_code:language, return_to:location.pathname + location.search + location.hash};
      for (const [name, value] of Object.entries(fields)) {
        const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value; form.append(input);
      }
      document.body.append(form); form.submit();
    } else {
      const target = new URL(language === 'en' ? '/' : `/${language}/`, location.origin);
      target.search = location.search; target.hash = location.hash;
      location.replace(target.pathname + target.search + target.hash);
    }
  };
  if (allowed.includes(saved)) { switchTo(saved); return; }
  const countryToLanguage = country => country === 'ME' ? 'sr' : 'en';
  const detect = async () => {
    try {
      const cached = sessionStorage.getItem('fabienne_detected_country');
      if (/^[A-Z]{2}$/.test(cached || '')) { switchTo(countryToLanguage(cached)); return; }
      if (config.mode !== 'shopify' && ['localhost', '127.0.0.1', '::1'].includes(location.hostname)) return;
      const endpoint = config.mode === 'shopify'
        ? (window.Shopify?.routes?.root || '/') + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false'
        : '/cdn-cgi/trace';
      const response = await fetch(endpoint, {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(1800)});
      if (!response.ok) return;
      let country;
      if (config.mode === 'shopify') country = (await response.json()).detected_values?.country?.handle;
      else country = (await response.text()).match(/^loc=([A-Z]{2})\s*$/m)?.[1];
      if (!/^[A-Z]{2}$/.test(country || '')) return;
      sessionStorage.setItem('fabienne_detected_country', country);
      const chosen = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(cookieName + '='))?.split('=')[1];
      if (!allowed.includes(chosen) && !document.querySelector('dialog[open]')) switchTo(countryToLanguage(country));
    } catch {}
  };
  detect();
})();
